import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { initializeFilterData } from "../../EnvConfig/env_config";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FindTranslatedKey, deleteData } from "../CommonComponents/CustomHooks";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { FormButton, InputBox, Switch } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const VendorMaster = ({ menuText }) => {
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [currentPageNo, setCurrentPageNo] = useState(1);
    let [result, setResult] = useState([]);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [disableEdit, setDisableEdit] = useState(false)
    const Hide = false;
    const [formData, setFormData] = useState({
        "vendorID": '',
        "vendorCode": '',
        "vendorName": '',
        "active": true
    })

    const handleClear = () => {
        setFormData({
            "vendorID": '',
            "vendorCode": '',
            "vendorName": '',
            "active": true
        });
        filterData.SearchText = ''
        getVendorMaster()
       // inputrefs.current['txtVendorCode'].focus();
        setDisableEdit(false)
    };

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Master/InsertUpdateVendorMaster', formData)
        await dispatch(setSubLoading(false))
        if (data.status === 'ERROR' || data.status === 'EXPIRED' || data.status === 'UNAUTHORIZED' || data.status === 'SUCCESS') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
        }
    }

    const handleDelete = async (ID) => {
        await dispatch(setSubLoading(true))
        await deleteData('/api/Master/DeleteVendorMaster', { vendorID: ID }, getVendorMaster, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleEdit = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall('/api/Master/EditVendorMaster', { vendorID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR'|| editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setDisableEdit(true)
            let record = editData.data
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }
    }

    const getVendorMaster = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/Master/ShowVendorMaster', GetData)
        setResult(data)
        setLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const handleChange1 = (event, value) => {
        getVendorMaster(value);
    };


    useEffect(() => {
        getVendorMaster();
    }, [sortConfig])

    useEffect(() => {
       // inputrefs.current['txtVendorCode'].focus();
        document.title = 'Vendor Master'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> {menuText ? menuText :FindTranslatedKey('Vendor Master')}</h6>
                </div>
                <div className='card-body row'>
                  {/*  {Hide ? <>*/}
                        <div className='row'>
                            <InputBox
                                label='Vendor Code'
                                PlaceHolderText='Vendor Code'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtVendorCode'
                                value={formData.vendorCode}
                                disabled={disableEdit}
                                maxLength='20'
                                onChange={(e) => {
                                    setFormData({ ...formData, vendorCode: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtVendorName'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Vendor Name'
                                PlaceHolderText='Vendor Name'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtVendorName'
                                value={formData.vendorName}
                                maxLength='50'
                                onChange={(e) => {
                                    setFormData({ ...formData, vendorName: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtActive'].focus();
                                    }
                                }}
                            />

                            <Switch
                                label='Active'
                                inputrefs={inputrefs}
                                id='txtActive'
                                checked={formData.active}
                                onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['btnSave'].focus() };
                                }}
                            />
                        </div>
                   {/* </> : <></>}*/}
                    <div className='row pb-1'>
                    <FormButton
                        id='btnSave'
                        inputrefs={inputrefs}
                        //save={false}
                        handleSubmit={handleSubmit}
                        handleExport={async () => {
                            await dispatch(setSubLoading(true))
                            await handleDownloadExcel('/api/Master/ShowVendorMaster', filterData, 'Vendor Master')
                            await dispatch(setSubLoading(false))
                        }}
                        handleClear={handleClear}
                    />
                    </div>
                    <Table handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        PageName={'VendorMaster'}
                        loading={loading}
                        handleFilter={() => {
                            getVendorMaster()
                            setFilterData({
                                ...filterData,
                            })
                        }}
                        filterData={filterData}
                        tableData={result}
                        setFilterData={setFilterData}
                        currentPageNo={currentPageNo}
                        handleChange1={handleChange1}
                        handleSorting={handleSorting}
                        sortConfig={sortConfig}
                    />
                </div>
               
            </div>
           
        </>
    )
}

export default VendorMaster;